import { render, staticRenderFns } from "./AppPieChartSvg.vue?vue&type=template&id=45be7a60&"
import script from "./AppPieChartSvg.vue?vue&type=script&lang=js&"
export * from "./AppPieChartSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports